import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  width: 100vw;
  background-color: red;
  margin: auto;
  justify-content: center;
`
export const Wrapper = styled.div`
  display: 'flex';
  flex-direction: column;
  background-color: green;
  width: 100%;
  max-width: 1440px;
`
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
export const HeaderTitle = styled.div`
  flex: 1;
`
export const Body = styled.div``
export const Footer = styled.div``
